/**
 * Maximum number of elements allowed for arrays when parsing a query string.
 */
export const QUERY_STRING_ARRAY_LIMIT = 520;
